import personName from './personName'
import { GENDER_TYPE } from '../../constants'

// This object represents the minimum data needed to create a new person.
export default Object.freeze({
  gender: {
    value: {
      type: GENDER_TYPE.unknown,
    },
  },
  names: [personName],
})
